import React from 'react';
import { Dropdown } from '@insurancemenu/imenu-components-lib';
import {
  ChevronDown,
  CloudUpload,
  Tools,
  InsertChart,
  Mail,
  Reload,
  CircleDown,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { observer } from 'mobx-react-lite';
import { bpHistory } from 'global/bpHistory';
import { useTriggerRenewalsPageStore } from 'store/pages/tools/trigger-renewals/pageStore';
import { generatePath } from 'react-router-dom';
import { ROUTES_CONFIG_V2, RouteV2Id } from 'routes/routesConfigV2';
import { DropdownButtonStyled } from './styles';

const MoreDropdown: React.FC = observer(() => {
  const {
    batchActionDelegate: { openWarningModal, generateExhibits },
    generateFilesForAutoRenewModalDelegate,
  } = useTriggerRenewalsPageStore();

  const moreActionsDropdownOptions: DropdownOptionType[] = [
    {
      value: 'triggerAll',
      onOptionClick: (): void => {
        openWarningModal('TRIGGER_ALL');
      },
      icon: Mail,
      label: 'Trigger All',
    },
    {
      value: 'sendStatistic',
      onOptionClick: (): void => {
        openWarningModal('SEND_STATISTICS');
      },
      icon: InsertChart,
      label: 'Send Statistics',
    },
    {
      value: 'uploadExhibits',
      onOptionClick: (): void => {
        bpHistory.push(generatePath(ROUTES_CONFIG_V2[RouteV2Id.UPLOAD_ALL_EXHIBITS].path));
      },
      icon: CloudUpload,
      label: 'Upload Exhibits',
    },
    {
      value: 'generateExhibits',
      onOptionClick: generateExhibits,
      icon: Tools,
      label: 'Generate Exhibits',
    },
    {
      value: 'autoRenew',
      onOptionClick: generateFilesForAutoRenewModalDelegate.open,
      icon: CircleDown,
      label: 'Auto-Renew',
    },
    {
      value: 'moveToRenewal',
      onOptionClick: (): void => {
        openWarningModal('MOVE_ALL_TO_RENEWAL');
      },
      icon: Reload,
      label: 'Move All to Renewal',
    },
  ];

  return (
    <Dropdown
      name="More"
      options={moreActionsDropdownOptions}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
      optionsWidth="25rem"
      closedElement={
        <DropdownButtonStyled color="primary" size="large" rightIconProp={<ChevronDown />}>
          MORE ACTIONS
        </DropdownButtonStyled>
      }
      openedElement={
        <DropdownButtonStyled color="primary" size="large" rightIconProp={<ChevronDown />}>
          MORE ACTIONS
        </DropdownButtonStyled>
      }
    />
  );
});

export default MoreDropdown;
